import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'hr',
  Pagination: {
    items_per_page: '/ str',
    jump_to: 'Idi na',
    jump_to_confirm: 'potvrdi',
    page: '',
    prev_page: 'Prijašnja stranica',
    next_page: 'Sljedeća stranica',
    prev_5: 'Prijašnjih 5 stranica',
    next_5: 'Sljedećih 5 stranica',
    prev_3: 'Prijašnje 3 stranice',
    next_3: 'Sljedeće 3 stranice',
  },
  DatePicker: {
    lang: {
      placeholder: 'Odaberite datum',
      yearPlaceholder: 'Odaberite godinu',
      quarterPlaceholder: 'Odaberite četvrtinu',
      monthPlaceholder: 'Odaberite mjesec',
      weekPlaceholder: 'Odaberite tjedan',
      rangePlaceholder: [
        'Početni datum',
        'Završni datum',
      ],
      rangeYearPlaceholder: [
        'Početna godina',
        'Završna godina',
      ],
      rangeMonthPlaceholder: [
        'Početni mjesec',
        'Završni mjesec',
      ],
      rangeWeekPlaceholder: [
        'Početni tjedan',
        'Završni tjedan',
      ],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće',
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme',
      rangePlaceholder: [
        'Vrijeme početka',
        'Vrijeme završetka',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Odaberite vrijeme',
    rangePlaceholder: [
      'Vrijeme početka',
      'Vrijeme završetka',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Odaberite datum',
      yearPlaceholder: 'Odaberite godinu',
      quarterPlaceholder: 'Odaberite četvrtinu',
      monthPlaceholder: 'Odaberite mjesec',
      weekPlaceholder: 'Odaberite tjedan',
      rangePlaceholder: [
        'Početni datum',
        'Završni datum',
      ],
      rangeYearPlaceholder: [
        'Početna godina',
        'Završna godina',
      ],
      rangeMonthPlaceholder: [
        'Početni mjesec',
        'Završni mjesec',
      ],
      rangeWeekPlaceholder: [
        'Početni tjedan',
        'Završni tjedan',
      ],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće',
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme',
      rangePlaceholder: [
        'Vrijeme početka',
        'Vrijeme završetka',
      ],
    },
  },
  global: {
    placeholder: 'Molimo označite',
  },
  Table: {
    filterTitle: 'Filter meni',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    filterEmptyText: 'Nema filtera',
    emptyText: 'Nema podataka',
    selectAll: 'Označi trenutnu stranicu',
    selectInvert: 'Invertiraj trenutnu stranicu',
    selectionAll: 'Odaberite sve podatke',
    sortTitle: 'Sortiraj',
    expand: 'Proširi redak',
    collapse: 'Sažmi redak',
    triggerDesc: 'Kliknite za sortiranje silazno',
    triggerAsc: 'Kliknite za sortiranje uzlazno',
    cancelSort: 'Kliknite da biste otkazali sortiranje',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Odustani',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Odustani',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Pretraži ovdje',
    itemUnit: 'stavka',
    itemsUnit: 'stavke',
    remove: 'Ukloniti',
    selectCurrent: 'Odaberite trenutnu stranicu',
    removeCurrent: 'Ukloni trenutnu stranicu',
    selectAll: 'Odaberite sve podatke',
    removeAll: 'Uklonite sve podatke',
    selectInvert: 'Obrni trenutnu stranicu',
  },
  Upload: {
    uploading: 'Upload u tijeku...',
    removeFile: 'Makni datoteku',
    uploadError: 'Greška kod uploada',
    previewFile: 'Pogledaj datoteku',
    downloadFile: 'Preuzmi datoteku',
  },
  Empty: {
    description: 'Nema podataka',
  },
  Icon: {
    icon: 'ikona',
  },
  Text: {
    edit: 'Uredi',
    copy: 'Kopiraj',
    copied: 'Kopiranje uspješno',
    expand: 'Proširi',
  },
  PageHeader: {
    back: 'Natrag',
  },
  Form: {
    optional: '(neobavezno)',
    defaultValidateMessages: {
      default: 'Pogreška provjere valjanosti polja za ${label}',
      required: 'Molimo unesite ${label}',
      enum: '${label} mora biti jedan od [${enum}]',
      whitespace: '${label} ne može biti prazan znak',
      date: {
        format: '${label} format datuma je nevažeći',
        parse: '${label} ne može se pretvoriti u datum',
        invalid: '${label} je nevažeći datum',
      },
      types: {
        string: '${label} nije valjan ${type}',
        method: '${label} nije valjan ${type}',
        array: '${label} nije valjan ${type}',
        object: '${label} nije valjan ${type}',
        number: '${label} nije valjan ${type}',
        date: '${label} nije valjan ${type}',
        boolean: '${label} nije valjan ${type}',
        integer: '${label} nije valjan ${type}',
        float: '${label} nije valjan ${type}',
        regexp: '${label} nije valjan ${type}',
        email: '${label} nije valjan ${type}',
        url: '${label} nije valjan ${type}',
        hex: '${label} nije valjan ${type}',
      },
      string: {
        len: '${label} mora biti ${len} slova',
        min: '${label} mora biti najmanje ${min} slova',
        max: '${label} mora biti do ${max} slova',
        range: '${label} mora biti između ${min}-${max} slova',
      },
      number: {
        len: '${label} mora biti jednak ${len}',
        min: '${label} mora biti minimalano ${min}',
        max: '${label} mora biti maksimalano ${max}',
        range: '${label} mora biti između ${min}-${max}',
      },
      array: {
        len: 'Mora biti ${len} ${label}',
        min: 'Najmanje ${min} ${label}',
        max: 'Najviše ${max} ${label}',
        range: 'Količina ${label} mora biti između ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} ne odgovara obrascu ${pattern}',
      },
    },
  },
  Image: {
    preview: 'Pregled',
  },
};

export default localeValues;
